<template>
  <li class="row-content" :class="containerClass">
    <div class="d-flex justify-content-between">
      <div class="t-overflow pr-1">
        <i class="t-secondary t-xs mr-1"
          :class="getFirstOrganisationIcon"
        />
        <span class="t-600 t-sm" v-html="getOrganisations"></span>
      </div>
      <div class="position-relative width--25px">
        <flag :title="renderCountryFlagTooltip(getFirstCountry)" v-if="organisations" :iso="getFirstCountry.alpha_2 | lowercase" :squared="false" class="flag bd-radius" />
      </div>
    </div>
  </li>
</template>

<script>

export default {
  name: 'searchPartialOrganisationForBody',
  props: {
    organisations: {
      type: Array,
      default: () => ([])
    },
    highlights: {
      type: Object,
      required: true
    },
    highlightKey: {
      type: String,
      required: false,
      default: 'organisation.name'
    },
    containerClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    getOrganisations () {
      if (!this.isEmpty(this.organisations)) {
        let mergedOrganisations = []
        for (let organisation of this.organisations) mergedOrganisations.push(this.getOrganisationName(organisation))
        return mergedOrganisations.join(', ')
      }
      return ''
    },
    getFirstCountry () {
      if (this.isEmpty(this.organisations)) return {}
      if (this.organisations[0].country) return this.organisations[0].country
      return {}
    },
    getFirstOrganisationIcon () {
      if (this.isEmpty(this.organisations)) return this.renderOrganisationCategoryIcon()
      if (this.organisations[0].organisation_types) {
        return this.renderOrganisationCategoryIcon(this.organisations[0].organisation_types)
      }
      return this.renderOrganisationCategoryIcon()
    }
  },
  methods: {
    getOrganisationName (organisation) {
      let nameKey = 'name'
      if (organisation.organisation_name) nameKey = 'organisation_name'
      if (organisation.full_name) nameKey = 'full_name'
      let org = organisation[nameKey]

      if (!this.isEmpty(this.highlights) && !this.isEmpty(this.highlightKeys)) {
        for (let highlightKey of this.highlightKeys) {
          for (let o of this.highlights[highlightKey]) if (organisation[nameKey] === this.stripTags(o)) org = o
          return org
        }
      } else if (this.highlights && this.highlights[this.highlightKey]) {
        for (let o of this.highlights[this.highlightKey]) if (organisation[nameKey] === this.stripTags(o)) org = o
        return org
      } else if (this.highlights && this.highlights['organisation_name']) {
        for (let o of this.highlights['organisation_name']) if (organisation[nameKey] === this.stripTags(o)) org = o
        return org
      }

      return organisation[nameKey]
    }
  }
}
</script>
